import { getText } from "../strings";

export function validateRange(min: number, max: number): string | undefined {
  if (min > max) {
    return getText("validation-range-min-greater-than-max");
  }
  return;
}
